
<script>
import { DropdownItem,Cell,Icon,Popup } from 'vant'
const _utils = require('vant/lib/utils')
const _createNamespace = (0, _utils.createNamespace)('dropdown-item')
const  bem = _createNamespace[1]
export default {
    extends:DropdownItem,
    props:{
        multiple:{
            type:Boolean,
            default:false
        }
    },
    render(h) {
    var _this$parent = this.parent,
        zIndex = _this$parent.zIndex,
        offset = _this$parent.offset,
        overlay = _this$parent.overlay,
        duration = _this$parent.duration,
        direction = _this$parent.direction,
        activeColor = _this$parent.activeColor,
        closeOnClickOverlay = _this$parent.closeOnClickOverlay;
    var Options = this.options.map( (option)=> {
        let active = false;
        if (this.multiple){
            active = this.value.includes(option.value)
        }else{
            active = option.value === this.value;
        }
      return h(Cell, {
        "attrs": {
          "clickable": true,
          "icon": option.icon,
          "title": option.text
        },
        "key": option.value,
        "class": bem('option', {
          active: active
        }),
        "style": {
          color: active ? activeColor : ''
        },
        "on": {
          "click": ()=> {
              if (this.multiple){
                  let newValue  = this.value
                  if (this.value.includes(option.value)){
                        newValue = newValue.filter(value=>value !== option.value)
                        this.$emit('input', newValue);
                        this.$emit('change',newValue);
                  }else{
                        newValue.push(option.value)
                        this.$emit('input', newValue);
                        this.$emit('change',newValue);
                  }
              }else{
                this.showPopup = false;
                if (option.value !== this.value) {
                    this.$emit('input', option.value);
                    this.$emit('change', option.value);
                }else{
                   this.$emit('input', '');
                    this.$emit('change', '');
                }
              }
          }
        }
      }, [active && h(Icon, {
        "class": bem('icon'),
        "attrs": {
          "color": activeColor,
          "name": "success"
        }
      })]);
    });
    var style = {
      zIndex: zIndex
    };

    if (direction === 'down') {
      style.top = offset + "px";
    } else {
      style.bottom = offset + "px";
    }
    return h("div", [h("div", {
      directives: [{
        name: "show",
        value: this.showWrapper
      }],
      ref: "wrapper",
      style: style,
      class: bem([direction]),
      on: {
        click:this.onClickWrapper
      }
    }, [h(Popup, {
      "attrs": {
        "overlay": overlay,
        "position": direction === 'down' ? 'top' : 'bottom',
        "duration": this.transition ? duration : 0,
        "closeOnClickOverlay": closeOnClickOverlay,
        "overlayStyle": {
          position: 'absolute'
        }
      },
      "class": bem('content'),
      "on": {
        "open": this.onOpen,
        "close": this.onClose,
        "opened": this.onOpened,
        "closed": ()=> {
          this.showWrapper = false;
          this.$emit('closed');
        }
      },
      "model": {
        value: this.showPopup,
        callback:  ($$v) => {
          this.showPopup = $$v;
        }
      }
    }, [Options, this.slots('default')])])]);

  },


}
</script>